import React, { useState, useEffect } from 'react';
import './findyouroptometrist.css';

// Sample optometrist data - replace with your actual data
const optometristsData = [
  {
    id: 1,
    name: "Nishamani Duruge",
    practice: "Optometrist",
    location: "Nishamani Duruge Optometrists",
    image: "/diploma/075.jpg",
    experience: "12 years",
    specialties: ["Pediatric Optometry", "Vision Therapy"],
    contact: "011 2233652",
 
  },
  {
    id: 2,
    name: "R. Sasikaran",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/060.jpg",
    experience: "8 years",
    specialties: ["Orthokeratology", "Myopia Control"],
    contact: "011 2233652",
   
  },
  {
    id: 3,
    name: "Nisansala",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/040.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",

  },
  {
    id: 4,
    name: "Lahiru Rodrigo",
    practice: "Optometrist",
    location: "Nawaloka Hospital, Colombo 02",
    image: "/diploma/079.jpg",
    experience: "5 years",
    specialties: ["Scleral Lenses", "Dry Eye Management"],
    contact: "011 2233652",

  },
  {
    id: 5,
    name: "B.A.D.T. Himidira",
    practice: "Optometrist",
    location: "Anura Opticals, Panadura",
    image: "/diploma/082.jpg",
    experience: "12 years",
    specialties: [ "Vision Therapy"],
    contact: "011 2233652",
 
  },
  {
    id: 6,
    name: "Isuru Sampath",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/071.jpg",
    experience: "8 years",
    specialties: ["Orthokeratology", "Myopia Control"],
    contact: "011 2233652",
   
  },
  {
    id: 7,
    name: "Premarathna",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/068.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",

  },
  {
    id: 8,
    name: "Lahiru Rodrigo",
    practice: "Optometrist",
    location: "Nawaloka Hospital",
    image: "/diploma/079.jpg",
    experience: "5 years",
    specialties: ["Scleral Lenses", "Dry Eye Management"],
    contact: "011 2233652",

  },
  {
    id: 9,
    name: "W. Anura Shantha Perera",
    practice: "Optometrist",
    location: "Anura Optical",
    image: "/diploma/052.jpg",
    experience: "12 years",
    specialties: ["Pediatric Optometry", "Vision Therapy"],
    contact: "011 2233652",
 
  },
  {
    id: 10,
    name: "N. Arul Kumar",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/066.jpg",
    experience: "8 years",
    specialties: ["Orthokeratology", "Myopia Control"],
    contact: "011 2233652",
   
  },
  {
    id: 11,
    name: "B. Prasad Gomis",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/064.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",

  },
  {
    id: 12,
    name: "N. Udeni Gurusinghe",
    practice: "Optometrist",
    location: "Nawaloka Hospital, Colombo 02",
    image: "/diploma/043.jpg",
    experience: "5 years",
    specialties: ["Scleral Lenses", "Dry Eye Management"],
    contact: "011 2233652",

  },
  {
    id: 13,
    name: "K. Dayalan",
    practice: "Optometrist",
    location: "Anura Opticals, Panadura",
    image: "/diploma/045.jpg",
    experience: "12 years",
    specialties: [ "Vision Therapy"],
    contact: "011 2233652",
 
  },
  {
    id: 14,
    name: "M. Lilendra Perera",
    practice: "Optometrist",
    location: "Panora Eye Hospital",
    image: "/diploma/044.jpg",
    experience: "8 years",
    specialties: ["Orthokeratology", "Myopia Control"],
    contact: "011 2233652",
   
  },
  {
    id: 15,
    name: "S.H.R. Premarathna",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/068.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",

  },
  {
    id: 16,
    name: "H.D. Sujanima R. Wijetunga",
    practice: "Optometrist",
    location: "Nawaloka Hospital",
    image: "/diploma/073.jpg",
    experience: "5 years",
    specialties: ["Scleral Lenses", "Dry Eye Management"],
    contact: "011 2233652",

  },
  {
    id: 17,
    name: "J.A. Darshi Lekha Wijerathne",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/0100.jpg",
    experience: "12 years",
    specialties: ["Pediatric Optometry", "Vision Therapy"],
    contact: "011 2233652",
  },
  {
    id: 18,
    name: "W. Sathya N. De Mel",
    practice: "Optometrist",
    location: "Hospital",
    image: "/diploma/0101.jpg",
    experience: "8 years",
    specialties: ["Orthokeratology", "Myopia Control"],
    contact: "011 2233652",
   
  },
  {
    id: 19,
    name: "Priyantha Mahanama",
    practice: "Optometrist",
    location: "Mahanama Optical",
    image: "/diploma/041.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",
  },
  {
    id: 20,
    name: "K.M.G. Dilrukshi Dias",
    practice: "Optometrist",
    location: "Optical",
    image: "/diploma/050.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",
  },
  {
    id: 21,
    name: " M. Suranga De Silva",
    practice: "Optometrist",
    location: "Optical",
    image: "/diploma/053.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",
  },
  {
    id: 22,
    name: "Prabhamali Siriwardhane",
    practice: "Optometrist",
    location: "Siriwardhane Optical",
    image: "/diploma/051.jpg",
    experience: "15 years",
    specialties: ["Low Vision", "Geriatric Optometry"],
    contact: "011 2233652",
  },
 
];

function FindYourOptometrist() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOptometrist, setSelectedOptometrist] = useState(null);
  const [filteredOptometrists, setFilteredOptometrists] = useState(optometristsData);
  const [activeFilter, setActiveFilter] = useState('all');

  useEffect(() => {
    const results = optometristsData.filter(optometrist => {
        const matchesSearch = 
          optometrist.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          optometrist.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
          optometrist.practice.toLowerCase().includes(searchTerm.toLowerCase());
      
        const matchesFilter =
          activeFilter === 'all' || 
          optometrist.practice.toLowerCase().includes(activeFilter.toLowerCase());
      
        return matchesSearch && matchesFilter;
      });
    setFilteredOptometrists(results);
    
    // Auto-select first result if none selected
    if (results.length > 0 && !selectedOptometrist) {
      setSelectedOptometrist(results[0]);
    } else if (results.length === 0) {
      setSelectedOptometrist(null);
    }
  }, [searchTerm, activeFilter]);

  const handleFilter = (filter) => {
    setActiveFilter(filter);
  };

  return (
    <div className="find-optometrist-container">
      <div className="hero-section">
        <h1>Find Your Optometrist</h1>
        <p className="subtitle">Connect with experienced eye care professionals near you</p>
        
        <div className="search-container-optometrist">
          <input
            type="text"
            placeholder="Search by name, location, or practice..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input-optometrist"
          />
        </div>
        
      </div>
      
      <div className="results-container">
        <div className="optometrist-list">
          {filteredOptometrists.length > 0 ? (
            filteredOptometrists.map(optometrist => (
              <div 
                key={optometrist.id}
                className={`optometrist-card ${selectedOptometrist?.id === optometrist.id ? 'selected' : ''}`}
                onClick={() => setSelectedOptometrist(optometrist)}
              >
                <div className="list-image-container">
                  <img src={optometrist.image} alt={optometrist.name} />
                </div>
                <div className="list-details">
                  <h3>{optometrist.name}</h3>
                  <p className="practice">{optometrist.practice}</p>
                  <p className="location">{optometrist.location}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              <i className="fas fa-eye-slash"></i>
              <p>No optometrists found matching your search</p>
            </div>
          )}
        </div>
        
        <div className="optometrist-detail">
          {selectedOptometrist ? (
            <div className="detail-card">
              <div className="detail-content">
                <div className="detail-info">
                  <h2>{selectedOptometrist.name}</h2>
                  <div className="badge-container">
                    <span className="practice-badge">{selectedOptometrist.practice}</span>
                    <span className="experience-badge">{selectedOptometrist.experience} experience</span>
                  </div>
                  
                  <div className="detail-section">
                    <h4>Location</h4>
                    <p><i className="fas fa-map-marker-alt"></i> {selectedOptometrist.location}</p>
                  </div>
                  
                  <div className="detail-section">
                    <h4>Specialties</h4>
                    <ul className="specialties-list">
                      {selectedOptometrist.specialties.map((specialty, index) => (
                        <li key={index}><i className="fas fa-check-circle"></i> {specialty}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="detail-section">
                    <h4>Contact</h4>
                    <p><i className="fas fa-phone"></i> {selectedOptometrist.contact}</p>
                  </div>
                  
                  <button className="appointment-btn">
                    Book Appointment <i className="fas fa-calendar-check"></i>
                  </button>
                </div>
                
                <div className="detail-image-container">
                  <img src={selectedOptometrist.image} alt={selectedOptometrist.name} />
                  <div className="image-overlay"></div>
                </div>
              </div>
            </div>
          ) : (
            <div className="select-prompt">
              <i className="fas fa-user-md"></i>
              <p>Select an optometrist to view details</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FindYourOptometrist;